import { cn } from "@/lib/utils"

/** Shared split-card chrome for sign-in / sign-up (signup-04 layout). */
export const AUTH_RADIUS_CLASS = "rounded-[6px]"

export const authSplitCardShellClass = (className?: string) =>
  cn("flex w-full min-w-0 flex-col gap-4", className)

export const authSplitCardClass = cn(
  "w-full overflow-hidden border border-solid border-border p-0 shadow-none ring-0 dark:bg-sidebar dark:text-sidebar-foreground",
  AUTH_RADIUS_CLASS
)

/**
 * Min height sized for expanded sign-up (password checklist + OAuth) so sign-in
 * matches on md+. Keep in sync with globals.css `[data-auth-mirrored-split]` min-height.
 */
export const AUTH_SPLIT_CARD_MIN_H_CLASS = "md:min-h-[56rem]"

export const authSplitCardContentClass = cn(
  "grid w-full p-0 md:grid-cols-2",
  AUTH_SPLIT_CARD_MIN_H_CLASS
)

export const authSplitFormClass = "flex h-full min-h-full flex-col p-6 md:p-8"

/** Sign-in: vertically center fields inside the tall split card (no top gap + footer spacer). */
export const authSplitFormCenteredClass = cn(authSplitFormClass, "justify-center")

export const authSplitFormFullWidthClass = cn(authSplitFormClass, "md:col-span-2")

export const authSplitFormFullWidthCenteredClass = cn(
  authSplitFormFullWidthClass,
  "justify-center"
)

/** Auth hero titles — larger than in-card labels; Urbanist, Tropical Surf. */
export const authWelcomeTitleClass =
  "font-[family-name:var(--font-primary)] text-3xl font-normal leading-tight text-[color:var(--brand-tropical-surf)] md:text-4xl"

/** Muted auth copy (forgot password, OAuth icons, legal links) — gray in light, white in dark. */
export const AUTH_MUTED_TEXT_CLASS =
  "text-gray-500 dark:!text-white"
